import style from 'components/Headings.module.scss'
import { motion } from 'framer-motion'
import {
  childVariants,
  contentVariants,
  parentVariants,
  rootVariants,
} from 'lib/constants'
import { formatMarkdown, widont } from 'lib/helpers'
import React from 'react'
import { useInView } from 'react-intersection-observer'

const Headings = ({ mainHeading, subHeading }) => {
  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  return (
    <div
      className={style.root}
      ref={ref}
      initial="initial"
      animate={inView ? 'animate' : 'initial'}
      exit="exit"
    >
      <div className={style.content}>
        <h2 className={style.mainHeading}>{widont(mainHeading)}</h2>
        {!!subHeading && (
          <div
            className={style.subHeading}
            dangerouslySetInnerHTML={{ __html: formatMarkdown(subHeading) }}
          />
        )}
      </div>
    </div>
  )
}

export default Headings
